import { type PostNftTransferV2Payload } from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';

import { postMultipleNftTransfer } from '../data-access/api';

/**
 * @returns withdraw multiple collectibles mutation object
 */
export const useMyCollectibleMultipleWithdrawMutation = () =>
	useMutation({ mutationFn: (payload: PostNftTransferV2Payload) => postMultipleNftTransfer(payload) });
